/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  globalLogger.ts
 */

import { Logger } from './BaseLogger'

import { LOG_LEVEL } from './types'

const globalObj: { logger?: Logger; logLevel?: LOG_LEVEL } = {
  logger: undefined,
  logLevel: undefined,
}

export const getGlobalLogger = (): Logger | undefined => globalObj.logger
export const getGlobalLogLevel = (): LOG_LEVEL | undefined => globalObj.logLevel

export const setGlobalLogger = (logger: Logger | undefined): void => {
  globalObj.logger = logger
}

export const setGlobalLogLevel = (logLevel: LOG_LEVEL | undefined): void => {
  globalObj.logLevel = logLevel
}
